import script from "./AmSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./AmSelect.vue?vue&type=script&setup=true&lang=js"

import "./AmSelect.vue?vue&type=style&index=0&id=74d347c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74d347c2"]])

export default __exports__